import { Box, Flex, Text } from '@chakra-ui/react'

export type ChartLegendItem =
  | { kind: 'line'; label: string; color: string; dashed?: boolean }
  | { kind: 'band'; label: string; fill: string }

export const ChartLegend = ({ items }: { items: ChartLegendItem[] }) => (
  <Flex
    wrap="wrap"
    gap={4}
    px={4}
    pt={2}
    pb={1}
    align="center"
    borderTop="1px solid"
    borderColor="gray.100"
    _dark={{ borderColor: 'whiteAlpha.100' }}>
    {items.map((item, i) => (
      <Flex key={`${item.kind}-${item.label}-${i}`} align="center" gap={1.5}>
        {item.kind === 'line' ? (
          <Box
            w="24px"
            h="2px"
            bg={item.dashed ? 'transparent' : item.color}
            borderTop={item.dashed ? `2px dashed ${item.color}` : 'none'}
            flexShrink={0}
          />
        ) : (
          <Box
            w="24px"
            h="10px"
            borderRadius="sm"
            bg={item.fill}
            flexShrink={0}
            border="1px solid"
            borderColor="gray.200"
            _dark={{ borderColor: 'whiteAlpha.200' }}
          />
        )}
        <Text fontSize="xs" fontFamily="hero-new" color="gray.500" _dark={{ color: 'gray.400' }}>
          {item.label}
        </Text>
      </Flex>
    ))}
  </Flex>
)
